export default __webpack_public_path__ + "static/media/website.9fe19cc4.PNG";